import React, { Fragment, useState } from "react";

import { getLanguageCode, getLanguageFromLocalStorage, useNavigate, useTranslation } from "utils";

import { SOIL_SIGHT_DEMO_VIDEO_BY_LANGUAGE_CODE } from "consts";

import { Button, Flex, LazyLoadImage, Tag, Typography, VideoOverlay } from "components";

import { useSoilSightScenariosAccessBase } from "pages/app/scenario-analysis/hooks/useSoilSightScenariosAccess";

export const SoilSightPromoCard = () => {
  const { t } = useTranslation("dashboard");
  const navigate = useNavigate();
  const { hasScenarios } = useSoilSightScenariosAccessBase();

  const [showVideoOverlay, setShowVideoOverlay] = useState(false);

  const titleLines = t("planningCard.soilSight.title")
    .split(". ")
    .map((line, index, lines) => (index < lines.length - 1 ? `${line}.` : line));

  const soilSightDemoVideoUrl = SOIL_SIGHT_DEMO_VIDEO_BY_LANGUAGE_CODE[getLanguageCode(getLanguageFromLocalStorage())];

  return (
    <>
      <Flex gap="0.75rem" align="stretch" className="soilsight-promo-card" data-testid="soilsight-promo-card">
        <Flex vertical gap="2rem" justify="space-between" className="soilsight-promo-card-copy">
          <Flex vertical gap="0.75rem">
            <Tag colour="yellow" text={t("planningCard.new")} className="soilsight-promo-card-badge" />
            <Typography variant="h1">
              {titleLines.map((line, index) => (
                <Fragment key={line}>
                  {index > 0 && <br />}
                  {line}
                </Fragment>
              ))}
            </Typography>
            <Typography variant="paragraph-l">{t("planningCard.soilSight.description")}</Typography>
          </Flex>
          <Flex gap="0.75rem" align="center" className="soilsight-promo-card-ctas">
            <Button
              type="primary"
              size="middle"
              onClick={() => navigate(hasScenarios ? "/scenarios" : "/scenarios-landing-page", { state: { entryPoint: "home_promo" } })}
            >
              {t("planningCard.soilSight.planCta")}
            </Button>
            {!!soilSightDemoVideoUrl && (
              <Button type="secondary" size="middle" onClick={() => setShowVideoOverlay(true)}>
                {t("planningCard.soilSight.viewDemoCta")}
              </Button>
            )}
          </Flex>
        </Flex>
        <div className="soilsight-promo-card-chart">
          <LazyLoadImage width="100%" height="100%" src="/images/homepage/soilSight-graph-banner.svg" alt="" />
        </div>
      </Flex>
      {!!soilSightDemoVideoUrl && <VideoOverlay visible={showVideoOverlay} vimeoId={soilSightDemoVideoUrl} onClose={() => setShowVideoOverlay(false)} />}
    </>
  );
};
